import { render, staticRenderFns } from "./CreateNightpayVoucherActionDescription.vue?vue&type=template&id=c9bf332a&"
import script from "./CreateNightpayVoucherActionDescription.vue?vue&type=script&lang=js&"
export * from "./CreateNightpayVoucherActionDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports